import { FC, useCallback, useState } from 'react';

import Marquee from "react-fast-marquee";
import { MarqueeNotifications } from './Marquee';
import { NotificationMessage } from './NotificationMessage';
import clsx from 'clsx';
import { useGetNotificationEvents } from './useGetNotificationEvents';
import { useNotification } from './useNotification';
import { IControlAttributes } from '../../../base/models';
import { Registry } from '../../../base/register';
import { ControlType } from '../../../base/types';

export const MarqueeComponent: FC<IControlAttributes> = ({
    className
}) => {
    const { notificationIds } = useGetNotificationEvents();
    const { records } = useNotification(notificationIds);
    const [selectedMessage, setSelectedMessage] = useState<string | null>(null);
    const [dialogOpen, setDialogOpen] = useState(false);

    const handleTextClick = (notificationId: string) => {
        const record = records.find(record => record.notificationId === notificationId);
        if (record) {
            setSelectedMessage(record.message || '');
            setDialogOpen(true);
        }
    };

    const handleClose = () => {
        setDialogOpen(false);
    };

    const renderMarquee = useCallback(() => {
        const texts = records.map(record => ({ name: record.name || "", notificationId: record.notificationId || "" }));

        return (
            <Marquee speed={40} direction='left' pauseOnHover={true}>
                <MarqueeNotifications
                    texts={texts}
                    onTextClick={handleTextClick}
                />
            </Marquee>
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [records]);

    return (
        <div className={clsx(className)}>
            {renderMarquee()}
            {selectedMessage && <NotificationMessage selectedMessage={selectedMessage} open={dialogOpen} handleClose={handleClose} />}
        </div>
    );
};

Registry.addControl({
    id: "c910c14c-5992-47e6-81fb-e1ee5c4ebce6",
    name: "Marquee",
    type: ControlType.Marquee,
    properties: [],
    component: MarqueeComponent,
})
